import {Inject, Injectable} from "@angular/core";
import {
    ActionService,
    component,
    ConfigurationService,
    dateField,
    EntityData,
    field,
    JwtHttpClientService,
    ResourceModule
} from "@fedelta-pos/data-client";
import {AddressData} from "../customer-info/address.data";

export class IntegratedDeliveryAddressValidationRequestData extends EntityData<IntegratedDeliveryAddressValidationRequestData> {
    @field storeId: number;
    @dateField expectedCompletion: Date;
    @component address: AddressData;
}

@Injectable()
export class IntegratedDeliveryAddressValidationService extends ActionService {
    constructor(http: JwtHttpClientService,
                configService: ConfigurationService,
                @Inject(ResourceModule.RESOURCE_NAMESPACE_KEY) nameSpace,
                @Inject(ResourceModule.ACTION_NAMES_KEY) actionNames) {
        console.log("--- IntegratedDeliveryAddressValidationService");

        super(http, configService, nameSpace, actionNames, "integrated-delivery-address-validation");
    }
}



// WEBPACK FOOTER //
// ./src/app/ordering-context/integrated-delivery-address-validation.service.ts